// ----------------------------------------------------------------------

export default {
  MuiPaper: {
    elevation: 0,
  },
}
